import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ExtraAmenities } from '../../models'
import { ExtraAmenitiesService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'

const log = new Logger('ExtraAmenitiesDetailResolver')
@Injectable({ providedIn: 'root' })
export class ExtraAmenitiesDetailResolver
  implements Resolve<Observable<ExtraAmenities>> {
  constructor(
    private extraService: ExtraAmenitiesService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['eid']
    
    return this.extraService.detail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/extraamenities']))
    )
  }
}
